import { createIcon } from "@chakra-ui/icons";

export const AdobexdLogo = createIcon({
  displayName: "AdobexdLogo",
  viewBox: "0 0 24 24",
  path: (
    <g clipPath="url(#clip0)">
      <path
        d="M4.042 0h12.916A3.539 3.539 0 0120.5 3.542v12.416a3.539 3.539 0 01-3.542 3.542H4.042A3.539 3.539 0 01.5 15.958V3.542A3.539 3.539 0 014.042 0z"
        fill="#470137"
      />
      <path
        d="M11.017 5.124l-2.5 4.125 2.666 4.375a.143.143 0 01.017.1c-.008.034-.042.009-.092.017H9.2c-.133 0-.225-.008-.283-.092-.175-.35-.359-.691-.534-1.041a33.608 33.608 0 00-.566-1.05c-.2-.359-.4-.717-.6-1.084H7.2c-.175.359-.367.717-.558 1.075-.192.359-.384.717-.567 1.067-.192.35-.383.708-.575 1.05-.033.083-.1.092-.192.092H3.475c-.033 0-.058.016-.058-.025a.116.116 0 01.016-.092l2.592-4.25L3.5 5.116c-.025-.033-.033-.067-.017-.083.017-.025.05-.034.084-.034h1.891c.042 0 .084.009.117.017a.236.236 0 01.083.075c.159.358.342.717.534 1.075.2.358.391.708.6 1.058.2.35.383.7.558 1.059h.017c.175-.367.358-.725.541-1.075.184-.35.375-.7.567-1.05.192-.35.375-.709.558-1.05.009-.034.025-.067.05-.084a.159.159 0 01.109-.016h1.758a.077.077 0 01.091.058c.009.008-.008.042-.024.058zM14.866 13.917a4.144 4.144 0 01-1.791-.375 2.906 2.906 0 01-1.259-1.134c-.308-.508-.458-1.141-.458-1.9a3.423 3.423 0 011.783-3.05c.584-.325 1.284-.483 2.109-.483.041 0 .1 0 .175.008.075.009.158.009.258.017V4.367c0-.059.025-.092.083-.092h1.692c.042-.008.075.025.083.058v7.95c0 .15.009.317.017.5.017.175.025.342.033.484 0 .058-.025.108-.083.133a6.365 6.365 0 01-1.358.4 7.35 7.35 0 01-1.284.117zm.817-1.667V8.583c-.075-.016-.15-.033-.225-.041-.092-.009-.183-.017-.275-.017-.325 0-.65.067-.942.217-.283.141-.525.35-.708.616-.183.267-.275.625-.275 1.059-.008.291.042.583.142.858.083.225.208.425.375.592.158.15.35.266.566.333.225.075.459.108.692.108.125 0 .242-.008.35-.016a.73.73 0 00.3-.042z"
        fill="#FF61F6"
      />
    </g>
  ),
});

export const AfipIcon = createIcon({
  displayName: "AfipIcon",
  viewBox: "0 0 312.44 85.35",
  path: (
    <g>
      <g>
        <path
          fill="currentcolor"
          d="M 45.582031 80.316406 C 45.421875 80.699219 44.707031 80.722656 44.492188 80.722656 L 4.710938 80.722656 L 38.835938 5.835938 C 39.183594 5.121094 39.574219 4.878906 40.375 4.878906 L 57.828125 4.878906 C 58.183594 4.878906 58.664063 5.085938 58.871094 5.523438 L 68.246094 27.035156 L 68.4375 27.476563 C 68.566406 27.78125 68.621094 27.976563 68.621094 28.175781 C 68.621094 28.390625 68.546875 28.648438 68.402344 28.972656 L 68.34375 29.09375 C 67.460938 31.109375 52.207031 65.421875 47.195313 76.699219 Z M 84.40625 63.894531 C 84.40625 64.605469 84.238281 65.175781 83.886719 65.660156 C 83.414063 66.355469 82.597656 66.800781 81.8125 66.800781 L 56.558594 66.8125 L 71.265625 33.71875 L 78.324219 49.34375 C 81.851563 57.15625 84.019531 61.953125 84.042969 62 C 84.285156 62.660156 84.40625 63.300781 84.40625 63.894531 M 72.367188 25.132813 L 62.972656 3.578125 C 61.964844 1.4375 59.898438 -0.00390625 57.828125 -0.00390625 L 40.375 -0.00390625 C 37.933594 -0.00390625 35.941406 1.359375 34.769531 3.84375 L 0.449219 79.136719 C -0.207031 80.734375 -0.140625 82.285156 0.625 83.496094 C 1.363281 84.675781 2.667969 85.351563 4.210938 85.351563 L 44.492188 85.351563 C 46.886719 85.351563 48.84375 84.179688 49.722656 82.214844 L 54.5 71.445313 L 81.605469 71.414063 C 81.707031 71.417969 81.816406 71.421875 81.921875 71.421875 C 84.085938 71.421875 86.253906 70.242188 87.574219 68.347656 C 89.097656 66.1875 89.351563 63.359375 88.277344 60.351563 "
        />
      </g>
      <path
        fill="currentcolor"
        d="M 216.761719 4.761719 C 217.03125 4.761719 217.265625 4.863281 217.464844 5.074219 C 217.847656 5.457031 218.070313 6.234375 218.070313 7.15625 L 218.050781 64.117188 C 218.050781 66.238281 216.3125 66.40625 216.292969 66.40625 L 183.3125 66.40625 C 182.855469 66.40625 182.011719 65.40625 182.011719 63.988281 L 182.011719 7.105469 C 181.980469 6.230469 182.160156 5.535156 182.492188 5.164063 C 182.734375 4.917969 183.09375 4.800781 183.585938 4.800781 Z M 216.726563 -0.00390625 L 183.558594 -0.00390625 C 181.917969 0.0195313 180.375 0.730469 179.214844 1.988281 C 178.097656 3.207031 177.484375 4.957031 177.484375 6.917969 L 177.484375 63.988281 C 177.484375 67.390625 179.824219 71.03125 183.3125 71.03125 L 216.292969 71.03125 C 219.3125 71.03125 222.570313 68.386719 222.570313 64.121094 L 222.597656 7.15625 C 222.597656 4.382813 221.546875 2.71875 220.660156 1.808594 C 219.539063 0.636719 218.144531 -0.00390625 216.726563 -0.00390625 "
      />
      <g>
        <path
          fill="currentcolor"
          d="M 269.082031 64.113281 C 269.082031 65.78125 267.285156 66.371094 266.824219 66.371094 L 234.804688 66.371094 C 234.304688 66.371094 233.957031 66.242188 233.679688 65.957031 C 233.277344 65.539063 233.03125 64.777344 233.03125 63.964844 L 233.03125 7.5 C 233.03125 6.457031 233.402344 4.714844 235.914063 4.714844 L 241.21875 4.71875 C 249.957031 4.722656 266.453125 4.722656 266.917969 4.730469 L 267.039063 4.734375 C 267.171875 4.734375 267.300781 4.726563 267.363281 4.714844 L 269.097656 4.714844 Z M 307.917969 7.136719 C 307.917969 7.753906 307.761719 8.425781 307.46875 9.085938 L 292.328125 43.40625 C 290.980469 46.402344 287.910156 46.851563 286.203125 46.851563 L 273.601563 46.878906 L 273.628906 4.714844 L 305.644531 4.710938 C 306.347656 4.8125 307.121094 5.007813 307.5625 5.722656 C 307.792969 6.132813 307.917969 6.621094 307.917969 7.136719 M 311.417969 3.316406 C 310.230469 1.328125 308.171875 0.117188 305.757813 -0.00390625 L 235.914063 -0.00390625 C 230.828125 -0.00390625 228.515625 3.882813 228.515625 7.5 L 228.515625 63.964844 C 228.515625 66.019531 229.226563 67.9375 230.472656 69.226563 C 231.597656 70.394531 233.089844 71.011719 234.78125 71.011719 L 266.824219 71.011719 C 269.664063 71.011719 273.59375 68.613281 273.59375 64.113281 L 273.601563 51.5 L 286.210938 51.484375 C 288.449219 51.484375 293.921875 50.886719 296.4375 45.339844 L 311.601563 10.992188 C 312.777344 8.308594 312.710938 5.441406 311.417969 3.316406 "
        />
      </g>
      <path
        fill="currentcolor"
        d="M 99.507813 6.964844 C 99.507813 5.214844 100.160156 4.617188 102.078125 4.617188 C 102.136719 4.617188 106.828125 4.636719 112.59375 4.65625 C 121.816406 4.691406 133.785156 4.734375 133.964844 4.734375 C 134.019531 4.734375 134.070313 4.730469 134.128906 4.730469 L 135.550781 4.730469 L 135.539063 64.234375 C 135.539063 66.324219 133.808594 66.496094 133.789063 66.496094 L 100.792969 66.496094 C 100.0625 66.496094 99.507813 65.691406 99.507813 64.625 Z M 146.148438 46.855469 L 140.0625 46.855469 L 140.070313 27.980469 L 155.304688 27.980469 C 155.546875 27.980469 155.773438 28.121094 155.921875 28.34375 C 156.023438 28.503906 156.0625 28.660156 156.0625 28.871094 C 156.0625 29.0625 156.027344 29.265625 155.953125 29.445313 L 155.859375 29.683594 C 154.605469 32.808594 151.46875 40.523438 149.414063 44.726563 C 148.371094 46.855469 148.371094 46.855469 146.148438 46.855469 M 166.699219 5.386719 C 166.699219 5.519531 166.683594 5.625 166.65625 5.691406 L 160.3125 19.703125 C 158.742188 23.441406 158.605469 23.441406 155.039063 23.441406 L 140.074219 23.441406 L 140.09375 4.730469 L 166.089844 4.730469 C 166.265625 4.730469 166.496094 4.765625 166.605469 4.992188 C 166.671875 5.089844 166.699219 5.214844 166.699219 5.386719 M 166.449219 -0.00390625 L 102.078125 -0.00390625 C 97.757813 -0.00390625 94.964844 2.730469 94.964844 6.964844 L 94.964844 64.625 C 94.964844 68.277344 97.527344 71.136719 100.792969 71.136719 L 133.789063 71.136719 C 136.804688 71.136719 140.058594 68.496094 140.058594 64.234375 L 140.070313 51.390625 L 145.648438 51.390625 C 147.621094 51.359375 149.292969 51.480469 150.601563 50.921875 C 151.433594 50.554688 152.117188 49.839844 152.703125 48.695313 L 158.878906 34.679688 C 158.976563 34.414063 159.183594 33.988281 159.449219 33.441406 C 159.761719 32.800781 160.152344 32.007813 160.554688 31.074219 C 160.871094 30.355469 161.234375 29.546875 161.617188 28.703125 L 162.808594 26.046875 C 163.226563 25.113281 163.636719 24.171875 164.089844 23.214844 C 164.289063 22.789063 164.484375 22.34375 164.679688 21.898438 C 164.929688 21.324219 165.179688 20.753906 165.4375 20.226563 L 171.144531 7.4375 C 171.859375 5.78125 171.734375 3.921875 170.808594 2.460938 C 169.828125 0.914063 168.199219 -0.00390625 166.449219 -0.00390625 "
      />
    </g>
  ),
});


export const AutenticaIcon = createIcon({
  displayName: "autenticaIcon",
  viewBox: "0 0 575.49 215.448",
  path: (
    <>
      <defs>
        <linearGradient
          id="b"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(78.24946 -78.24946) rotate(4.728 56.373 68.2)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" style={{ stopOpacity: 1, stopColor: "#031666" }} />
          <stop offset=".195" style={{ stopOpacity: 1, stopColor: "#0075e0" }} />
          <stop offset=".667" style={{ stopOpacity: 1, stopColor: "#00deef" }} />
          <stop offset="1" style={{ stopOpacity: 1, stopColor: "#00deef" }} />
        </linearGradient>
        <linearGradient
          id="c"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(84.63924 -84.63924) rotate(4.728 53.173 62.338)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" style={{ stopOpacity: 1, stopColor: "#031666" }} />
          <stop offset=".195" style={{ stopOpacity: 1, stopColor: "#0075e0" }} />
          <stop offset=".667" style={{ stopOpacity: 1, stopColor: "#00deef" }} />
          <stop offset="1" style={{ stopOpacity: 1, stopColor: "#00deef" }} />
        </linearGradient>
        <linearGradient
          id="d"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(84.63924 -84.63924) rotate(4.728 50.565 62.23)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" style={{ stopOpacity: 1, stopColor: "#031666" }} />
          <stop offset=".195" style={{ stopOpacity: 1, stopColor: "#0075e0" }} />
          <stop offset=".667" style={{ stopOpacity: 1, stopColor: "#00deef" }} />
          <stop offset="1" style={{ stopOpacity: 1, stopColor: "#00deef" }} />
        </linearGradient>
        <linearGradient
          id="e"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(84.63924 -84.63924) rotate(4.728 50.842 62.242)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" style={{ stopOpacity: 1, stopColor: "#031666" }} />
          <stop offset=".195" style={{ stopOpacity: 1, stopColor: "#0075e0" }} />
          <stop offset=".667" style={{ stopOpacity: 1, stopColor: "#00deef" }} />
          <stop offset="1" style={{ stopOpacity: 1, stopColor: "#00deef" }} />
        </linearGradient>
        <linearGradient
          id="f"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(65.6215 -65.6215) rotate(-41.035 -4.53 -13.977)"
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
        >
          <stop offset="0" style={{ stopOpacity: 1, stopColor: "#031666" }} />
          <stop offset=".313" style={{ stopOpacity: 1, stopColor: "#0075e0" }} />
          <stop offset="1" style={{ stopOpacity: 1, stopColor: "#00deef" }} />
        </linearGradient>
        <clipPath id="a" clipPathUnits="userSpaceOnUse">
          <path d="M0 768h1366V0H0Z" />
        </clipPath>
        <clipPath id="g" clipPathUnits="userSpaceOnUse">
          <path d="M0 768h1366V0H0Z" />
        </clipPath>
      </defs>
      <g clipPath="url(#a)" transform="matrix(1.33333 0 0 -1.33333 -599.627 619.724)">
        <path
          d="M0 0v-84.143c-3.413-.526-6.279-.789-9.282-.789h-.094c-5.205.009-9.461 4.191-9.461 9.204v32.341l.682 12.359-3.413-9.597-15.015-36.419a66.6 66.6 0 0 0-8.463-.526c-2.457 0-5.188.132-8.6.526l-15.835 36.55-3.14 8.02.546-10.913v-32.304c0-5.015-4.261-9.231-9.469-9.241h-.086c-3.14 0-5.733.263-9.282.789V-.132C-88.319.526-85.042.92-80.674.92c3.549 0 7.235-.263 11.056-.788l23.616-52.064 1.638-4.207 1.365 4.207L-21.158.132C-17.2.657-14.879.92-10.374.92-6.961.92-3.686.657 0 0"
          style={{ fill: "#031666", fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
          transform="translate(548.268 447.853)"
        />
        <path
          d="M0 0v54.643c3.276.657 6.689.788 10.102.788 3.275 0 6.689-.131 10.237-.788v-63.65c-3.276-.526-6.688-.789-10.237-.789h-.099C4.501-9.787 0-5.299 0 0"
          style={{ fill: "#031666", fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
          transform="translate(558.52 372.717)"
        />
      </g>
      <path
        d="M463.546 351.87c-7.636 0-13.826-6.19-13.826-13.826v-3.912h69.055v17.738z"
        style={{ fill: "#00c1eaff", stroke: "none" }}
        transform="matrix(1.33333 0 0 -1.33333 -599.627 619.724)"
      />
      <path
        d="M553.073 352.009v-17.738h15.053c9.756 0 17.738 7.982 17.738 17.738z"
        style={{ fill: "#00c1eaff", stroke: "none" }}
        transform="matrix(1.33333 0 0 -1.33333 -599.627 619.724)"
      />
      <path
        d="m508.152 338 44.925-34.654 8.374 15.94-42.242 32.584z"
        style={{ fill: "#00c1eaff", stroke: "none" }}
        transform="matrix(1.33333 0 0 -1.33333 -599.627 619.724)"
      />
      <path
        d="M553.073 352.009v-48.802l5.724 6.203c4.032 4.37 7.332 12.808 7.332 18.753v23.846z"
        style={{ fill: "#00c1eaff", stroke: "none" }}
        transform="matrix(1.33333 0 0 -1.33333 -599.627 619.724)"
      />
      <path
        d="m570.029 462-1.339-1.373-1.338 1.373a9.155 9.155 0 0 1-6.561 2.793c-2.373 0-4.742-.936-6.554-2.793-3.627-3.729-3.627-9.773 0-13.505l14.453-13.204 13.118 11.829 1.335 1.375c3.628 3.732 3.628 9.776 0 13.505-1.811 1.857-4.18 2.793-6.553 2.793a9.154 9.154 0 0 1-6.561-2.793"
        style={{ fill: "#00c1eaff", stroke: "none" }}
        transform="matrix(1.33333 0 0 -1.33333 -599.627 619.724)"
      />
      <g clipPath="url(#g)" transform="matrix(1.33333 0 0 -1.33333 -599.627 619.724)">
        <path
          d="M0 0v59.146c2.975.597 6.074.716 9.172.716 2.975 0 6.074-.119 9.296-.716V-8.179a58.647 58.647 0 0 0-9.296-.716h-.089C4.087-8.887 0-4.812 0 0"
          style={{ fill: "#031666", fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
          transform="translate(800.578 342.473)"
        />
        <path
          d="M0 0h-12.427l6.07 11.26c2.269 3.803 7.326 8.669 12.838 8.669l18.346-.072C24.827 8.355 10.809 0 0 0"
          style={{ fill: "#031666", fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
          transform="translate(813.886 411.984)"
        />
        <path
          d="M0 0c12.508 0 19.265 4.514 19.265 14.045 0 9.029-6.592 12.853-19.265 12.853h-12.791V0Zm-2.027 40.802c11.555 0 16.554 4.716 16.554 12.184 0 8.137-5.412 11.258-16.306 11.258h-11.012V40.802Zm-29.29 37.952H-.8c19.061 0 33.454-5.609 33.454-23.056 0-8.584-4.689-17.308-12.502-20.165v-.572c9.84-2.404 17.239-9.511 17.239-22.045 0-18.807-15.489-27.426-35.694-27.426h-33.014z"
          style={{ fill: "#031666", fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
          transform="translate(624.992 349.114)"
        />
        <path
          d="M0 0v14.125c-16.885-2.213-22.463-6.84-22.463-13.088 0-5.41 3.668-7.891 9.066-7.891C-8.197-6.854-4.447-4.272 0 0m-40.19-.419c0 14.963 12.054 22.904 40.19 25.925-.318 6.888-3.345 12.092-11.881 12.092-6.413 0-12.612-2.832-19.054-6.66l-3.036 5.61c-2.075 3.832-.571 8.671 3.337 10.548 6.668 3.202 14.158 5.398 22.236 5.398 17.635 0 26.842-10.571 26.842-31.131v-40.997H3.366L2-12.118h-.482c-6.069-5.303-12.951-9.228-20.999-9.228-12.462 0-20.709 8.853-20.709 20.927"
          style={{ fill: "#031666", fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
          transform="translate(705.334 354.238)"
        />
        <path
          d="M0 0h13.099a5.345 5.345 0 0 0 5.345-5.344V-24.35l-.8-13.512c5.55 5.326 12.419 10.467 21.95 10.467 15.055 0 21.557-10.754 21.557-28.88v-45.024H42.708v42.577c0 11.152-3.007 15.03-9.799 15.03-5.681 0-9.301-2.816-14.465-8.035v-41.646c0-4.359-3.45-7.926-7.666-7.926H0Z"
          style={{ fill: "#031666", fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
          transform="translate(731.686 435.903)"
        />
        <path
          d="M0 0h18.444v-66.38H7.666C3.449-66.38 0-62.813 0-58.453Z"
          style={{ fill: "#031666", fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
          transform="translate(800.576 400.984)"
        />
        <path
          d="M0 0v14.125c-16.885-2.213-22.463-6.84-22.463-13.088 0-5.41 3.668-7.891 9.067-7.891C-8.197-6.854-4.447-4.272 0 0m-40.19-.419c0 14.963 12.054 22.904 40.19 25.925-.318 6.888-3.345 12.092-11.881 12.092-6.413 0-12.612-2.832-19.054-6.66l-3.036 5.61c-2.097 3.872-.611 8.652 3.337 10.548 6.669 3.202 14.158 5.398 22.236 5.398 17.635 0 26.842-10.571 26.842-31.131v-40.997H3.366l-1.365 7.516h-.483c-6.068-5.303-12.951-9.228-20.998-9.228-12.462 0-20.71 8.853-20.71 20.927"
          style={{ fill: "#031666", fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
          transform="translate(862.893 354.238)"
        />
      </g>
    </>
  ),
});
export const MiBahiaIcon = createIcon({
  displayName: "MiBahiaIcon",
  viewBox: "0 0 160 29",
  path: (
    <g>
      <path d="M1.672 18.5L4.104 4.592C4.674 1.362 6.612 0.715998 8.17 0.715998C11.248 0.715998 11.932 2.502 13.49 7.366L16.492 16.676H16.568L19.57 7.366C21.128 2.502 21.812 0.715998 24.89 0.715998C26.448 0.715998 28.386 1.362 28.956 4.592L31.388 18.5C31.882 21.312 32.414 24.39 32.414 25.302C32.414 26.67 31.35 28.228 29.526 28.228C26.752 28.228 26.258 26.252 25.954 24.162L24.13 12.154H24.054L19.912 25.454C19.304 27.43 18.392 28.228 16.53 28.228C14.668 28.228 13.756 27.43 13.148 25.454L9.006 12.154H8.93L7.106 24.162C6.802 26.252 6.308 28.228 3.534 28.228C1.71 28.228 0.646 26.67 0.646 25.302C0.646 24.39 1.178 21.312 1.672 18.5ZM40.7025 3.984V24.96C40.7025 27.126 39.4105 28.228 37.6245 28.228C35.8385 28.228 34.5465 27.126 34.5465 24.96V3.984C34.5465 1.818 35.8385 0.715998 37.6245 0.715998C39.4105 0.715998 40.7025 1.818 40.7025 3.984Z" fill="#4383D4" />
      <path d="M60.4075 6.416V11.508H63.2195C64.9675 11.508 66.0315 10.634 66.0315 8.962C66.0315 7.29 65.0055 6.416 63.2195 6.416H60.4075ZM54.2515 24.922V4.022C54.2515 2.046 55.7335 0.944 57.3295 0.944H64.5875C69.2615 0.944 72.1875 3.832 72.1875 8.012C72.1875 10.786 70.2495 12.42 68.9575 13.18C72.2635 13.826 74.3915 16.448 74.3915 19.83C74.3915 24.124 71.6175 28 64.9675 28H57.3295C55.7335 28 54.2515 26.898 54.2515 24.922ZM60.4075 16.98V22.528H64.2835C66.3355 22.528 68.0075 21.806 68.0075 19.754C68.0075 17.702 66.1075 16.98 64.2835 16.98H60.4075ZM76.1689 21.92L82.0969 5.922C83.1989 2.92 84.1489 0.335998 87.2269 0.335998C90.3809 0.335998 91.3309 2.92 92.4329 5.922L98.3609 21.92C99.1589 24.086 99.2729 24.808 99.2729 25.72C99.2729 27.24 98.0569 28.228 96.3089 28.228C94.2949 28.228 93.6489 26.936 93.0789 25.226L92.3189 22.794H82.2109L81.4509 25.226C80.8809 26.936 80.2349 28.228 78.2209 28.228C76.4729 28.228 75.2569 27.24 75.2569 25.72C75.2569 24.808 75.3709 24.086 76.1689 21.92ZM90.4949 17.094L87.4169 7.176H87.3409L84.0349 17.094H90.4949ZM106.868 16.98V24.96C106.868 27.126 105.576 28.228 103.79 28.228C102.004 28.228 100.712 27.126 100.712 24.96V3.984C100.712 1.818 102.004 0.715998 103.79 0.715998C105.576 0.715998 106.868 1.818 106.868 3.984V11.28H118.344V3.984C118.344 1.818 119.636 0.715998 121.422 0.715998C123.208 0.715998 124.5 1.818 124.5 3.984V24.96C124.5 27.126 123.208 28.228 121.422 28.228C119.636 28.228 118.344 27.126 118.344 24.96V16.98H106.868ZM133.624 3.984V24.96C133.624 27.126 132.332 28.228 130.546 28.228C128.76 28.228 127.468 27.126 127.468 24.96V3.984C127.468 1.818 128.76 0.715998 130.546 0.715998C132.332 0.715998 133.624 1.818 133.624 3.984ZM135.989 21.92L141.917 5.922C143.019 2.92 143.969 0.335998 147.047 0.335998C150.201 0.335998 151.151 2.92 152.253 5.922L158.181 21.92C158.979 24.086 159.093 24.808 159.093 25.72C159.093 27.24 157.877 28.228 156.129 28.228C154.115 28.228 153.469 26.936 152.899 25.226L152.139 22.794H142.031L141.271 25.226C140.701 26.936 140.055 28.228 138.041 28.228C136.293 28.228 135.077 27.24 135.077 25.72C135.077 24.808 135.191 24.086 135.989 21.92ZM150.315 17.094L147.237 7.176H147.161L143.855 17.094H150.315Z" fill="#94C144" />
    </g>
  ),
});

export const EscritorioIcon = createIcon({
  displayName: "escritorioIcon",
  viewBox: "0 0 77 79",
  path: (
    <g>
      <path d="M62.9796 9.72141C62.1696 9.18141 61.0796 9.39141 60.5296 10.1914L44.3696 34.0714C43.8196 34.8714 44.0296 35.9714 44.8296 36.5114C45.1196 36.7114 45.4696 36.8214 45.8196 36.8114H74.6496C75.6196 36.8114 76.4096 36.0214 76.4096 35.0514C76.4096 24.9014 71.3696 15.4014 62.9596 9.71141L62.9796 9.72141ZM49.1496 33.3014L62.4296 13.6714C68.5496 18.4214 72.3396 25.5714 72.8496 33.3014H49.1496Z" fill="currentcolor" />
      <path d="M44.2222 24.8C44.3922 24.85 44.5622 24.88 44.7422 24.88C45.3222 24.88 45.8722 24.59 46.2022 24.1L58.1722 6.41C58.7122 5.61 58.5022 4.51 57.7022 3.97H57.6922C53.8722 1.38 49.3622 0 44.7522 0C43.7822 0 42.9922 0.78 42.9922 1.76V23.12C42.9922 23.89 43.4922 24.58 44.2422 24.8H44.2222ZM46.5022 3.6C49.2122 3.84 51.8422 4.64 54.2222 5.96L46.5022 17.37V3.6Z" fill="currentcolor" />
      <path d="M66.07 42.6912H35.67V12.2912C35.67 11.3212 34.88 10.5312 33.91 10.5312C15.19 10.5512 0.02 25.7213 0 44.4412C0.01 63.1813 15.2 78.3512 33.93 78.3412C52.64 78.3312 67.81 63.1613 67.82 44.4513C67.82 43.4813 67.04 42.6912 66.06 42.6912H66.07ZM32.15 74.7812C15.39 73.8112 2.6 59.4412 3.57 42.6812C4.46 27.2812 16.75 15.0012 32.15 14.1012V44.4412C32.15 45.4113 32.94 46.2013 33.91 46.2013H64.25C63.28 62.9613 48.91 75.7513 32.15 74.7812Z" fill="currentcolor" />
    </g>
  ),
});


export const CalendarioIcon = createIcon({
  displayName: "calendarioIcon",
  viewBox: "0 0 27 29",
  path: (
    <g>
      <path d="M26.9946 5.02796C26.9946 3.19249 25.7754 1.95442 23.9654 1.89224C23.4981 1.87603 23.0281 1.89224 22.4669 1.89224H22.2252V0H20.7079V1.88954H6.10951V0H4.5922V1.88954H4.51164C3.93963 1.88954 3.49115 1.87603 3.04267 1.88954C1.23264 1.95172 0.010742 3.18978 0.00805649 5.01985C-0.0026855 11.9644 -0.0026855 18.9062 0.00805649 25.8508C0.010742 27.7187 1.27024 28.9919 3.10981 28.9946C10.033 29.0027 16.9589 29.0027 23.8821 28.9946C25.7244 28.9946 26.9893 27.7241 26.9919 25.8589C27.0027 18.9143 27.0027 11.9725 26.9919 5.02796H26.9946ZM25.3618 25.4318C25.3618 26.4698 24.524 27.3132 23.4927 27.3132H3.50995C2.47871 27.3132 1.64084 26.4698 1.64084 25.4318V9.53691H25.3592V25.4318H25.3618ZM25.3618 8.04474H1.62741V4.96309C1.62741 4.0494 2.36324 3.30872 3.27094 3.30872H23.7156C24.6233 3.30872 25.3592 4.0494 25.3592 4.96309V8.04474H25.3618Z" fill="currentcolor" />
      <path d="M6.28415 20.312H4.80176V21.8474H6.28415V20.312Z" fill="currentcolor" />
      <path d="M6.29734 14.7109H4.80957V16.2031H6.29734V14.7109Z" fill="currentcolor" />
      <path d="M11.5527 20.312H10.0703V21.8474H11.5527V20.312Z" fill="currentcolor" />
      <path d="M11.5669 14.7109H10.0791V16.2031H11.5669V14.7109Z" fill="currentcolor" />
      <path d="M16.8222 20.312H15.3398V21.8474H16.8222V20.312Z" fill="currentcolor" />
      <path d="M16.8354 14.7109H15.3477V16.2031H16.8354V14.7109Z" fill="currentcolor" />
      <path d="M22.0908 20.312H20.6084V21.8474H22.0908V20.312Z" fill="currentcolor" />
      <path d="M22.104 14.7109H20.6162V16.2031H22.104V14.7109Z" fill="currentcolor" />
    </g>

  ),
});

export const NotificacionesIcon = createIcon({
  displayName: "notificacionesIcon",
  viewBox: "0 0 70 44",
  path: (
    <g>
      <path d="M0.953125 0.539062V43.8591H69.7831V0.539062H0.953125ZM66.1831 4.12906V8.82906L35.4031 23.7991L4.54313 8.82906V4.12906H66.1931H66.1831ZM4.54313 40.2691V12.6491L34.6331 27.2391C34.8731 27.3591 35.1431 27.4191 35.4031 27.4191C35.6631 27.4191 35.9331 27.3591 36.1831 27.2391L66.1931 12.6491V40.2591H4.54313V40.2691Z" fill="currentcolor" />
    </g>
  ),
});

export const ServiciosIcon = createIcon({
  displayName: "serviciosIcon",
  viewBox: "0 0 66 71",
  path: (
    <g>
      <path d="M3.93971 41.3897C1.02971 43.2697 -0.0302887 47.0597 1.46971 50.1897C1.85971 50.9997 2.27971 51.7997 2.72971 52.5797C3.16971 53.3397 3.63971 54.0897 4.12971 54.8097C6.10971 57.7097 9.92971 58.7097 13.0097 57.1297C15.2697 55.9697 17.9197 56.0397 20.1097 57.3097C22.2697 58.5597 23.6497 60.7897 23.8097 63.2697C24.0397 66.8397 26.7097 69.6297 30.1497 69.8997C31.0597 69.9697 31.9797 70.0097 32.8997 70.0097C33.8197 70.0097 34.7197 69.9697 35.6197 69.8997C39.0697 69.6297 41.7497 66.8397 41.9797 63.2597C42.1397 60.7697 43.5197 58.5397 45.6797 57.2997C47.8697 56.0297 50.5297 55.9697 52.7897 57.1297C55.8497 58.6997 59.6197 57.7797 61.5597 54.9797C62.6097 53.4697 63.5397 51.8597 64.3397 50.1897C65.8397 47.0597 64.7697 43.2797 61.8697 41.3997C59.7397 40.0197 58.4697 37.6897 58.4697 35.1497C58.4697 32.6197 59.7397 30.2897 61.8597 28.9097C64.7597 27.0297 65.8297 23.2497 64.3297 20.1097C63.9397 19.2997 63.5197 18.4997 63.0697 17.7197C62.6397 16.9697 62.1697 16.2197 61.6697 15.4897C59.6897 12.5897 55.8697 11.5897 52.7797 13.1697C50.5197 14.3197 47.8697 14.2597 45.6797 12.9997C43.5197 11.7497 42.1397 9.51968 41.9797 7.03968C41.7497 3.46968 39.0797 0.679688 35.6397 0.409688C33.8197 0.269688 31.9797 0.269688 30.1697 0.409688C26.7197 0.679688 24.0397 3.46969 23.8097 7.04969C23.6497 9.53969 22.2697 11.7697 20.1097 13.0097C17.9197 14.2797 15.2597 14.3397 12.9997 13.1797C9.93971 11.6097 6.16971 12.5297 4.22971 15.3297C3.17971 16.8497 2.24971 18.4597 1.44971 20.1297C-0.0502892 23.2597 1.01971 27.0397 3.91971 28.9197C6.04971 30.2997 7.31971 32.6297 7.31971 35.1697C7.31971 37.6897 6.04971 40.0197 3.92971 41.3997L3.93971 41.3897ZM5.93971 44.4697C9.10971 42.4097 11.0097 38.9297 10.9997 35.1597C10.9997 31.3797 9.09971 27.8997 5.92971 25.8397C4.56971 24.9597 4.06971 23.1797 4.77971 21.7097C5.48971 20.2197 6.32971 18.7797 7.26971 17.4197C8.15971 16.1297 9.91971 15.7097 11.3497 16.4497C14.7197 18.1797 18.6897 18.0797 21.9697 16.1897C25.1897 14.3297 27.2497 11.0097 27.4897 7.28968C27.5997 5.54968 28.8597 4.19969 30.4797 4.06969C32.0997 3.93969 33.7497 3.93969 35.3697 4.06969C36.9797 4.19969 38.2297 5.54968 38.3397 7.27968C38.5797 10.9897 40.6497 14.3197 43.8697 16.1797C47.1397 18.0697 51.0997 18.1697 54.4697 16.4497C55.9197 15.7097 57.7197 16.1897 58.6597 17.5697C59.0997 18.2197 59.5197 18.8897 59.9097 19.5597C60.3097 20.2497 60.6897 20.9697 61.0397 21.6997C61.7497 23.1697 61.2497 24.9497 59.8897 25.8297C56.7197 27.8897 54.8197 31.3697 54.8297 35.1497C54.8297 38.9297 56.7297 42.4097 59.8997 44.4697C61.2597 45.3497 61.7597 47.1297 61.0497 48.5997C60.3397 50.0897 59.4997 51.5297 58.5697 52.8897C57.6797 54.1797 55.9297 54.5997 54.4897 53.8597C51.1197 52.1297 47.1497 52.2297 43.8697 54.1197C40.6497 55.9797 38.5897 59.3097 38.3397 63.0197C38.2297 64.7597 36.9697 66.1097 35.3497 66.2397C33.7297 66.3697 32.0797 66.3697 30.4597 66.2397C28.8497 66.1097 27.5997 64.7597 27.4897 63.0297C27.2497 59.3197 25.1797 55.9897 21.9597 54.1297C20.2397 53.1297 18.3297 52.6297 16.4097 52.6297C14.6797 52.6297 12.9497 53.0397 11.3497 53.8497C9.89971 54.5897 8.10971 54.1097 7.16971 52.7297C6.72971 52.0897 6.30971 51.4097 5.91971 50.7297C5.51971 50.0397 5.13971 49.3197 4.78971 48.5897C4.07971 47.1197 4.57971 45.3397 5.94971 44.4497L5.93971 44.4697Z" fill="currentcolor" />
      <path d="M32.9096 49.5197C41.3296 49.5197 48.1796 42.6697 48.1796 34.2497C48.1796 25.8297 41.3296 18.9797 32.9096 18.9797C24.4896 18.9797 17.6396 25.8297 17.6396 34.2497C17.6396 42.6697 24.4896 49.5197 32.9096 49.5197ZM32.9096 22.6397C39.3096 22.6397 44.5196 27.8497 44.5196 34.2497C44.5196 40.6497 39.3096 45.8597 32.9096 45.8597C26.5096 45.8597 21.2996 40.6497 21.2996 34.2497C21.2996 27.8497 26.5096 22.6397 32.9096 22.6397Z" fill="currentcolor" />
    </g>
  ),
});

export const ReclamosIcon = createIcon({
  displayName: "reclamosIcon",
  viewBox: "0 0 80 71",
  path: (
    <g>
      <path d="M45.9597 0.252197C31.6397 0.252197 19.3997 7.5722 14.6497 17.8222C6.04969 22.4022 0.929688 30.0622 0.929688 38.4122C0.979688 43.7922 3.03969 48.9522 6.70969 52.8822V68.9322C6.70969 69.8722 7.47969 70.6422 8.41969 70.6422C8.80969 70.6422 9.18969 70.5022 9.49969 70.2622L20.3897 61.4222C23.9697 62.5422 27.6897 63.1022 31.4397 63.1022C40.6797 63.2922 49.5797 59.6322 56.0197 53.0022C56.7397 52.8222 57.4597 52.6222 58.1697 52.3922L70.2297 62.1822C70.5297 62.4322 70.9097 62.5622 71.3097 62.5622C71.5597 62.5622 71.8197 62.5022 72.0397 62.3922C72.6397 62.1122 73.0097 61.5122 73.0097 60.8522V43.1122C77.0497 38.8122 79.3197 33.1422 79.3697 27.2422C79.3697 12.3522 64.3797 0.242188 45.9497 0.242188M31.4197 59.6622C27.7297 59.6722 24.0597 59.0722 20.5697 57.8822C20.0097 57.6922 19.3897 57.8022 18.9397 58.1722L10.1197 65.3322V52.2022C10.1197 51.7622 9.94969 51.3422 9.64969 51.0322C6.30969 47.6722 4.39969 43.1422 4.33969 38.4022C4.52969 32.1222 7.74969 26.3322 12.9797 22.8522V22.9422C12.8397 23.5722 12.7497 24.2122 12.6797 24.8522C12.6697 24.9822 12.6597 25.1222 12.6397 25.2522C12.5797 25.9022 12.5397 26.5622 12.5397 27.2322C12.5397 42.1222 27.5297 54.2322 45.9597 54.2322C46.5597 54.2322 47.1597 54.2222 47.7397 54.1922L48.1197 54.1722C48.6097 54.1522 49.1097 54.1122 49.5997 54.0722H49.7197C44.3497 57.7822 37.9597 59.7422 31.4397 59.6622M70.0697 41.2622C69.7697 41.5822 69.5997 42.0022 69.5997 42.4322V57.2522L59.6097 49.1322C59.3097 48.8822 58.9297 48.7522 58.5297 48.7522C58.3397 48.7522 58.1497 48.7822 57.9697 48.8422C56.9097 49.2022 55.8397 49.5122 54.7397 49.7822H54.7197C52.6397 50.2822 50.5197 50.6022 48.3897 50.7422L47.9897 50.7622C47.3197 50.8022 46.6397 50.8222 45.9597 50.8222C29.4197 50.8222 15.9597 40.2422 15.9597 27.2422C15.9597 26.6622 15.9997 26.0822 16.0497 25.5122C16.0497 25.4022 16.0697 25.3022 16.0797 25.1922C16.1397 24.6122 16.2297 24.0322 16.3497 23.4622L16.3697 23.3922C16.6397 22.1422 17.0297 20.9122 17.5297 19.7322C21.5297 10.4022 32.7597 3.67221 45.9597 3.67221C62.4997 3.67221 75.9597 14.2522 75.9597 27.2522C75.8897 32.5122 73.7697 37.5422 70.0597 41.2822" fill="currentcolor" />
      <path d="M45.9597 0.252197C31.6397 0.252197 19.3997 7.5722 14.6497 17.8222C6.04969 22.4022 0.929688 30.0622 0.929688 38.4122C0.979688 43.7922 3.03969 48.9522 6.70969 52.8822V68.9322C6.70969 69.8722 7.47969 70.6422 8.41969 70.6422C8.80969 70.6422 9.18969 70.5022 9.49969 70.2622L20.3897 61.4222C23.9697 62.5422 27.6897 63.1022 31.4397 63.1022C40.6797 63.2922 49.5797 59.6322 56.0197 53.0022C56.7397 52.8222 57.4597 52.6222 58.1697 52.3922L70.2297 62.1822C70.5297 62.4322 70.9097 62.5622 71.3097 62.5622C71.5597 62.5622 71.8197 62.5022 72.0397 62.3922C72.6397 62.1122 73.0097 61.5122 73.0097 60.8522V43.1122C77.0497 38.8122 79.3197 33.1422 79.3697 27.2422C79.3697 12.3522 64.3897 0.242188 45.9597 0.242188V0.252197ZM31.4297 59.6722C27.7397 59.6822 24.0697 59.0822 20.5797 57.8922C20.0197 57.7022 19.3997 57.8122 18.9497 58.1822L10.1297 65.3422V52.2122C10.1297 51.7722 9.95969 51.3522 9.65969 51.0422C6.31969 47.6822 4.40969 43.1522 4.34969 38.4122C4.53969 32.1322 7.75969 26.3422 12.9897 22.8622V22.9522C12.8497 23.5822 12.7597 24.2222 12.6897 24.8622C12.6797 24.9922 12.6697 25.1322 12.6497 25.2622C12.5897 25.9122 12.5497 26.5722 12.5497 27.2422C12.5497 42.1322 27.5397 54.2422 45.9697 54.2422C46.5697 54.2422 47.1697 54.2322 47.7497 54.2022L48.1297 54.1822C48.6197 54.1622 49.1197 54.1222 49.6097 54.0822H49.7297C44.3597 57.8022 37.9697 59.7522 31.4397 59.6722H31.4297ZM70.0597 41.2722C69.7597 41.5922 69.5897 42.0122 69.5897 42.4422V57.2622L59.5897 49.1422C59.2897 48.8922 58.9097 48.7622 58.5097 48.7622C58.3197 48.7622 58.1297 48.7922 57.9497 48.8522C56.8897 49.2122 55.8197 49.5222 54.7197 49.7922H54.6997C52.6197 50.2922 50.4997 50.6122 48.3697 50.7522L47.9697 50.7722C47.2997 50.8122 46.6197 50.8322 45.9397 50.8322C29.3997 50.8322 15.9397 40.2522 15.9397 27.2522C15.9397 26.6722 15.9797 26.0922 16.0297 25.5222C16.0297 25.4122 16.0497 25.3122 16.0597 25.2022C16.1197 24.6222 16.2097 24.0422 16.3297 23.4722L16.3497 23.4022C16.6197 22.1522 17.0097 20.9222 17.5097 19.7422C21.5097 10.4122 32.7397 3.68219 45.9397 3.68219C62.4797 3.68219 75.9397 14.2622 75.9397 27.2622C75.8597 32.5222 73.7497 37.5522 70.0297 41.2822L70.0597 41.2722Z" fill="currentcolor" />
      <path d="M32.6997 19.2822H37.1997C38.1397 19.2822 38.9097 18.5222 38.9097 17.5722C38.9097 16.6222 38.1497 15.8622 37.1997 15.8622H32.6997C31.7597 15.8622 30.9897 16.6222 30.9897 17.5722C30.9897 18.5222 31.7497 19.2822 32.6997 19.2822Z" fill="currentcolor" />
      <path d="M32.6997 19.2822H37.1997C38.1397 19.2822 38.9097 18.5222 38.9097 17.5722C38.9097 16.6222 38.1497 15.8622 37.1997 15.8622H32.6997C31.7597 15.8622 30.9897 16.6222 30.9897 17.5722C30.9897 18.5222 31.7497 19.2822 32.6997 19.2822Z" fill="currentcolor" />
      <path d="M59.2096 15.8722H44.7696C43.8296 15.8722 43.0596 16.6322 43.0596 17.5822C43.0596 18.5322 43.8196 19.2922 44.7696 19.2922H59.2196C60.1596 19.2922 60.9296 18.5322 60.9296 17.5822C60.9296 16.6322 60.1696 15.8722 59.2196 15.8722" fill="currentcolor" />
      <path d="M59.2096 15.8722H44.7696C43.8296 15.8722 43.0596 16.6322 43.0596 17.5822C43.0596 18.5322 43.8196 19.2922 44.7696 19.2922H59.2196C60.1596 19.2922 60.9296 18.5322 60.9296 17.5822C60.9296 16.6322 60.1696 15.8722 59.2196 15.8722H59.2096Z" fill="currentcolor" />
      <path d="M59.2097 25.4122H32.6997C31.7597 25.4122 30.9897 26.1722 30.9897 27.1222C30.9897 28.0722 31.7497 28.8322 32.6997 28.8322H59.2097C60.1497 28.8322 60.9197 28.0722 60.9197 27.1222C60.9197 26.1722 60.1597 25.4122 59.2097 25.4122Z" fill="currentcolor" />
      <path d="M59.2097 25.4122H32.6997C31.7597 25.4122 30.9897 26.1722 30.9897 27.1222C30.9897 28.0722 31.7497 28.8322 32.6997 28.8322H59.2097C60.1497 28.8322 60.9197 28.0722 60.9197 27.1222C60.9197 26.1722 60.1597 25.4122 59.2097 25.4122Z" fill="currentcolor" />
      <path d="M50.0297 34.9622H32.6997C31.7597 35.0022 31.0197 35.7922 31.0497 36.7322C31.0797 37.6222 31.7997 38.3422 32.6997 38.3822H50.0297C50.9697 38.3422 51.7097 37.5522 51.6797 36.6122C51.6497 35.7222 50.9297 35.0022 50.0297 34.9622Z" fill="currentcolor" />
      <path d="M50.0297 34.9622H32.6997C31.7597 35.0022 31.0197 35.7922 31.0497 36.7322C31.0797 37.6222 31.7997 38.3422 32.6997 38.3822H50.0297C50.9697 38.3422 51.7097 37.5522 51.6797 36.6122C51.6497 35.7222 50.9297 35.0022 50.0297 34.9622Z" fill="currentcolor" />
      <path d="M59.2096 34.9622H56.5796C55.6396 35.0022 54.8996 35.7922 54.9296 36.7322C54.9596 37.6222 55.6796 38.3422 56.5796 38.3822H59.2096C60.1496 38.3422 60.8896 37.5522 60.8596 36.6122C60.8296 35.7222 60.1096 35.0022 59.2096 34.9622Z" fill="currentcolor" />
      <path d="M59.2096 34.9622H56.5796C55.6396 35.0022 54.8996 35.7922 54.9296 36.7322C54.9596 37.6222 55.6796 38.3422 56.5796 38.3822H59.2096C60.1496 38.3422 60.8896 37.5522 60.8596 36.6122C60.8296 35.7222 60.1096 35.0022 59.2096 34.9622Z" fill="currentcolor" />
    </g>
  ),
});




export const DocumentosIcon = createIcon({
  displayName: "documentosIcon",
  viewBox: "0 0 79 94",
  path: (
    <g>
      <path d="M23.3631 93.3888C23.8431 93.3888 24.3231 93.2088 24.6931 92.8388L32.0231 85.5088C32.7531 84.7788 32.7531 83.5887 32.0231 82.8587L31.0431 81.8788L35.8131 77.1087C36.0831 76.8387 36.4531 76.6888 36.8331 76.6888H52.2731C54.4431 76.6888 56.4931 75.8388 58.0231 74.3088L77.7931 54.5388C78.1431 54.1888 78.3431 53.7088 78.3431 53.2088C78.3431 52.7088 78.1431 52.2388 77.7931 51.8788C72.3931 46.4788 63.6031 46.4788 58.2131 51.8788L53.8831 56.2088C53.6831 54.6988 53.0331 53.2788 51.9931 52.1388C50.5731 50.5788 48.5431 49.6788 46.4331 49.6788H27.6931C25.9531 49.6788 24.3231 50.3587 23.0931 51.5787L11.9231 62.7488L10.5431 61.3688C9.84313 60.6688 8.59313 60.6688 7.89313 61.3688L0.563125 68.7088C-0.166875 69.4388 -0.166875 70.6287 0.563125 71.3587L22.0431 92.8388C22.4131 93.2088 22.8931 93.3888 23.3731 93.3888H23.3631ZM25.7531 54.2388C26.2731 53.7188 26.9631 53.4288 27.6931 53.4288H46.4231C47.4831 53.4288 48.4931 53.8788 49.2131 54.6588C49.9331 55.4488 50.2731 56.4888 50.1731 57.5688C49.9931 59.4688 48.2431 60.9588 46.1831 60.9588H37.0331C35.9931 60.9588 35.1531 61.7988 35.1531 62.8388C35.1531 63.8788 35.9931 64.7188 37.0331 64.7188H49.8931C50.3931 64.7188 50.8631 64.5188 51.2231 64.1688L60.8531 54.5388C64.3331 51.0588 69.7531 50.6588 73.6831 53.3388L55.3631 71.6588C54.5331 72.4888 53.4331 72.9388 52.2631 72.9388H36.8231C35.4531 72.9388 34.1231 73.4888 33.1531 74.4588L28.3831 79.2288L14.5931 65.3988L25.7431 54.2488L25.7531 54.2388ZM9.21313 65.3587L28.0431 84.1888L23.3631 88.8688L4.53313 70.0388L9.21313 65.3587Z" fill="currentcolor" />
      <path d="M46.7233 9.62875L43.1333 3.34875C42.2933 1.87875 40.7033 0.96875 38.9833 0.96875H24.9233C21.4633 0.96875 18.6533 3.70876 18.6533 7.06876V35.2387C18.6533 38.5987 21.4633 41.3387 24.9233 41.3387H63.4933C66.9533 41.3387 69.7633 38.5987 69.7633 35.2387V15.7288C69.7633 12.3588 66.9533 9.62875 63.4933 9.62875H46.7133H46.7233ZM66.0233 15.7288V35.2387C66.0233 36.5387 64.8933 37.5887 63.5033 37.5887H24.9133C23.5233 37.5887 22.3933 36.5387 22.3933 35.2387V7.06876C22.3933 5.76876 23.5233 4.71875 24.9133 4.71875H38.9733C39.3533 4.71875 39.6933 4.90876 39.8633 5.19876L43.9933 12.4287C44.3233 13.0187 44.9533 13.3788 45.6233 13.3788H63.4833C64.8733 13.3788 66.0033 14.4288 66.0033 15.7288H66.0233Z" fill="currentcolor" />
    </g>
  ),
});



export const LicenciasIcon = createIcon({
  displayName: "licenciasIcon",
  viewBox: "0 0 583 367",
  path: (
    <g>

      <image id="image0_247_35" width="609" height="382" xlinkHref="./licencia.png" />

    </g>
  ),
});


export const TramitesIcon = createIcon({
  displayName: "tramitesIcon",
  viewBox: "0 0 54 66",
  path: (
    <g>
      <path d="M44.505 65.3775H3.525C3.545 65.0975 3.315 65.1375 3.155 65.0575C1.465 64.1775 0.635 62.8275 0.645 60.8875C0.665 44.2575 0.685 27.6275 0.625 10.9975C0.625 8.5575 2.565 6.33751 5.145 6.50751C6.325 6.58751 7.525 6.51752 8.665 6.51752C8.725 6.28752 8.785 6.19748 8.775 6.10748C8.455 3.58748 9.345 1.6675 11.605 0.4375H41.335C41.275 0.9175 41.705 1.06749 41.955 1.29749C45.435 4.47749 48.905 7.65753 52.435 10.7775C53.195 11.4475 53.475 12.1175 53.465 13.1175C53.415 18.4575 53.445 23.7875 53.445 29.1275C53.445 37.0075 53.395 44.8975 53.475 52.7775C53.505 55.2175 51.515 57.4775 48.945 57.2675C48.445 57.2275 47.905 57.1275 47.335 57.4175C47.335 58.5675 47.295 59.7075 47.335 60.8575C47.405 62.7975 46.565 64.1675 44.855 65.0375C44.705 65.1175 44.465 65.0875 44.505 65.3675V65.3775ZM49.305 53.1875V14.5675H38.195V4.61749C35.735 4.33749 13.805 4.43752 12.855 4.70752V53.1975H49.305V53.1875ZM4.755 10.6175V61.2575H43.255V57.2675C42.665 57.2675 42.145 57.2675 41.625 57.2675C33.785 57.2675 25.945 57.2675 18.105 57.2675C16.375 57.2675 14.645 57.2975 12.915 57.2675C10.545 57.2275 8.865 55.5375 8.795 53.1575C8.785 52.8175 8.795 52.4875 8.795 52.1475C8.795 38.8275 8.795 25.5075 8.795 12.1875V10.6275H4.765L4.755 10.6175ZM46.085 10.5275C44.735 9.35753 43.685 8.15748 42.285 7.16748V10.5275H46.085Z" fill="currentcolor" />
      <path d="M16.9951 26.6775V22.8575H45.1851C45.4351 24.0975 45.2251 25.3675 45.3051 26.6775H16.9951Z" fill="currentcolor" />
      <path d="M16.9849 42.9475V39.1275H45.2349V42.9475H16.9849Z" fill="currentcolor" />
      <path d="M16.9849 31.0175H45.1849C45.4349 32.2175 45.2349 33.4375 45.3149 34.7675H16.9849C16.8749 33.5475 16.8949 32.3175 16.9849 31.0175Z" fill="currentcolor" />
      <path d="M16.9751 14.5275V10.6675H34.0351V14.5275H16.9751Z" fill="currentcolor" />
    </g>
  ),
});

export const SaludIcon = createIcon({
  displayName: "saludIcon",
  viewBox: "0 0 60 60",
  path: (
    <g>
      <path d="M34.8803 59.4206H24.5403C19.7303 59.4206 15.8303 55.5206 15.8303 50.7106V43.9106H9.03031C4.22031 43.9106 0.320312 40.0106 0.320312 35.2006V24.8606C0.320312 20.0506 4.22031 16.1506 9.03031 16.1506H15.8303V9.35059C15.8303 4.54059 19.7303 0.640625 24.5403 0.640625H34.8803C39.6903 0.640625 43.5903 4.54059 43.5903 9.35059V16.1506H50.3903C55.2003 16.1506 59.1003 20.0506 59.1003 24.8606V35.2006C59.1003 40.0106 55.2003 43.9106 50.3903 43.9106H43.5903V50.7106C43.5903 55.5206 39.6903 59.4206 34.8803 59.4206ZM9.04031 20.9406C6.87031 20.9406 5.12031 22.7006 5.12031 24.8606V35.2006C5.12031 37.3706 6.88031 39.1206 9.04031 39.1206H20.6203V50.7006C20.6203 52.8706 22.3803 54.6206 24.5403 54.6206H34.8803C37.0503 54.6206 38.8003 52.8606 38.8003 50.7006V39.1206H50.3803C52.5503 39.1206 54.3003 37.3606 54.3003 35.2006V24.8606C54.3003 22.6906 52.5403 20.9406 50.3803 20.9406H38.8003V9.3606C38.8003 7.1906 37.0403 5.44061 34.8803 5.44061H24.5403C22.3703 5.44061 20.6203 7.2006 20.6203 9.3606V20.9406H9.04031Z" fill="currentcolor" />
    </g>
  ),
});

export const MbbIcon = createIcon({
  displayName: "MbbIcon",
  viewBox: "0 0 1080 608",
  path: (
    <g>
      <path
        fill="currentColor"
        d="M575.059,364.354v117.043c0,15.601-4.178,27.495-12.54,35.667c-8.357,8.17-19.225,12.266-32.6,12.266
	c-13.378,0-24.245-4.096-32.608-12.266c-8.362-8.172-12.54-20.066-12.54-35.667V173.746c0-15.609,4.178-27.496,12.54-35.668
	c8.363-8.177,19.23-12.265,32.608-12.265c13.375,0,24.242,4.088,32.6,12.265c8.362,8.172,12.54,20.059,12.54,35.668v107.01h29.673
	h76.055h29.669v-107.01c0-15.609,4.184-27.496,12.544-35.668c8.355-8.177,19.228-12.265,32.604-12.265s24.245,4.088,32.601,12.265
	c8.369,8.172,12.545,20.059,12.545,35.668v307.651c0,15.601-4.176,27.495-12.545,35.667c-8.355,8.17-19.225,12.266-32.601,12.266
	s-24.248-4.096-32.604-12.266c-8.36-8.172-12.544-20.066-12.544-35.667V364.354h-29.669h-76.055H575.059z M248.664,364.354v81.376
	h56.846c36.41,0,54.619-13.567,54.619-40.688c0-13.747-5.294-23.966-15.883-30.654c-10.59-6.692-23.504-10.033-38.736-10.033
	H248.664z M248.664,209.412v74.683h41.243c13.005,0,23.123-3.15,30.372-9.472c7.248-6.319,10.869-15.602,10.869-27.866
	c0-24.895-13.75-37.345-41.241-37.345H248.664z M158.374,480.841V174.304c0-13.753,4.46-24.706,13.374-32.88
	c8.922-8.18,19.504-12.26,31.768-12.26h106.455c33.811,0,60.841,9.564,81.092,28.701c20.252,19.129,30.371,44.116,30.371,74.958
	c0,31.949-15.793,57.22-47.37,75.798c24.151,4.833,43.47,16.074,57.962,33.717c14.492,17.657,21.738,38.924,21.738,63.815
	c0,34.186-11.52,62.708-34.563,85.554c-23.035,22.852-57.591,34.279-103.658,34.279H203.516c-12.264,0-22.846-4.088-31.768-12.266
	C162.834,505.552,158.374,494.586,158.374,480.841 M930.916,173.746v307.651c0,15.601-4.178,27.495-12.54,35.667
	c-8.364,8.17-19.23,12.266-32.604,12.266c-13.378,0-24.245-4.096-32.604-12.266c-8.356-8.172-12.541-20.066-12.541-35.667V173.746
	l0.497-1.102l45.844,71.288l43.943-71.06L930.916,173.746z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="currentColor"
        d="M886.082,54.67c31.455,0,56.945,31.155,56.945,62.605
	l-55.823,90.275l-58.056-90.275C829.148,85.825,854.639,54.67,886.082,54.67"
      />
    </g>
  ),
});

export const AtlassianLogo = createIcon({
  displayName: "AtlassianLogo",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        d="M6.427 9.239a.57.57 0 00-.798-.108.591.591 0 00-.167.209l-4.9 9.803a.586.586 0 00.524.847h6.827a.562.562 0 00.523-.324c1.474-3.043.58-7.67-2.01-10.427z"
        fill="#2684FF"
      />
      <path
        d="M10.028.318a12.932 12.932 0 00-.755 12.765l3.292 6.583a.586.586 0 00.523.324h6.826a.583.583 0 00.586-.585c0-.091-.02-.18-.06-.262L11.024.315a.552.552 0 00-.997 0v.003z"
        fill="#2684FF"
      />
    </g>
  ),
});

export const CartIcon = createIcon({
  displayName: "CartIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M7.984 19.937a1.406 1.406 0 100-2.812 1.406 1.406 0 000 2.812zM17.828 19.937a1.406 1.406 0 100-2.812 1.406 1.406 0 000 2.812zM20.324 5.558a1.051 1.051 0 00-.815-.386H6.134l-.27-1.528a.703.703 0 00-.692-.581H2.359a.703.703 0 000 1.406h2.223L6.59 15.841a.703.703 0 00.692.581h11.25a.703.703 0 100-1.406H7.871l-.248-1.406h10.62a1.057 1.057 0 001.035-.848l1.266-6.328a1.055 1.055 0 00-.22-.876z"
    />
  ),
});

export const ClockIcon = createIcon({
  displayName: "ClockIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <g>
        <rect fill="none" height="24" width="24" />
      </g>
      <g>
        <g>
          <g>
            <path
              fill="currentColor"
              d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M16.2,16.2L11,13V7h1.5v5.2l4.5,2.7L16.2,16.2z"
            />
          </g>
        </g>
      </g>
    </g>
  ),
});
export const CreativeTimLogo = createIcon({
  displayName: "CreativeTimLogo",
  viewBox: "0 0 100 100",
  path: (
    <g
      xmlns="http://www.w3.org/2000/svg"
      width="50px"
      height="50px"
      version="1.1"
    >
      <g
        id="logo-creative-tim-black"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="icon"
          transform="translate(15.000000, 19.000000)"
          fill="currentColor"
          fillRule="nonzero"
        >
          <path
            d="M66.4346744,1.49018376e-13 L3.56968951,1.49018376e-13 C1.59820443,1.49018376e-13 -2.98036753e-13,1.59820443 -2.98036753e-13,3.56968951 L-2.98036753e-13,33.5035241 C-2.98036753e-13,35.4750091 1.59820443,37.0732136 3.56968951,37.0732136 L16.4677598,37.0732136 L16.4677598,66.4346744 C16.4666001,67.3810129 16.8417189,68.288989 17.5104719,68.9585615 C18.1792249,69.628134 19.0867408,70.0043639 20.03308,70.0043639 L49.9669146,70.0043639 C51.9383997,70.0043639 53.5366041,68.4061595 53.5366041,66.4346744 L53.5366041,37.0863214 L66.4346744,37.0863214 C67.3810136,37.0863221 68.2885296,36.7100915 68.9572826,36.0405189 C69.6260355,35.3709464 70.0011544,34.4629704 70,33.5166319 L70,3.56968951 C70.0011544,2.62335099 69.6260355,1.71537495 68.9572826,1.04580242 C68.2885296,0.37622988 67.3810136,1.49018376e-13 66.4346744,1.49018376e-13 Z M4.13769396,4.14206323 L32.9311503,4.14206323 L32.9311503,32.9355196 L4.13769396,32.9355196 L4.13769396,4.14206323 Z M49.3989102,65.86667 L20.6054538,65.86667 L20.6054538,37.0863214 L49.3989102,37.0863214 L49.3989102,65.86667 Z M65.8623007,32.9355196 L37.0688443,32.9355196 L37.0688443,4.14206323 L65.8623007,4.14206323 L65.8623007,32.9355196 Z"
            id="Shape"
          />
          <path
            d="M23.6988934,23.3056595 C24.5142794,24.0708897 25.7898859,24.0506562 26.5805917,23.2599503 C27.3712976,22.4692445 27.3915311,21.193638 26.6263009,20.378252 L20.015603,13.767554 C19.2050095,12.9645312 17.8987889,12.9645312 17.0881954,13.767554 L10.4600204,20.378252 C9.90907005,20.8953125 9.68342943,21.6713831 9.87125954,22.4032422 C10.0590897,23.1351013 10.6305787,23.7065903 11.3624377,23.8944204 C12.0942968,24.0822505 12.8703675,23.8566099 13.387428,23.3056595 L18.5344222,18.1586654 L23.6988934,23.3056595 Z"
            id="Path"
          />
          <path
            d="M46.3185783,23.3056595 L51.4655725,18.1586654 L56.6125667,23.3056595 C57.4279526,24.0708897 58.7035592,24.0506562 59.494265,23.2599503 C60.2849709,22.4692445 60.3052044,21.193638 59.5399742,20.378252 L52.9292763,13.767554 C52.1186828,12.9645312 50.8124622,12.9645312 50.0018687,13.767554 L43.3911708,20.378252 C42.6259406,21.193638 42.6461741,22.4692445 43.43688,23.2599503 C44.2275858,24.0506562 45.5031924,24.0708897 46.3185783,23.3056595 L46.3185783,23.3056595 Z"
            id="Path"
          />
          <path
            d="M29.8508185,46.6987044 C29.0342976,45.9346441 27.7586832,45.9567597 26.9691385,46.7486649 C26.1795937,47.54057 26.1612859,48.8162446 26.9277802,49.6304812 L33.5384782,56.2368099 C33.9262423,56.6258256 34.452915,56.8444779 35.002182,56.8444779 C35.5514489,56.8444779 36.0781217,56.6258256 36.4658857,56.2368099 L43.0765837,49.6304812 C43.6002952,49.1075502 43.8052442,48.3449453 43.6142284,47.6299323 C43.4232126,46.9149194 42.8652519,46.3561259 42.1505246,46.1640439 C41.4357974,45.971962 40.6728876,46.1757734 40.1491761,46.6987044 L35.002182,51.8500678 L29.8508185,46.6987044 Z"
            id="Path"
          />
        </g>
      </g>
    </g>
  ),

  //   <chakra.svg
  //   height="50px"
  //   width="50px"
  //   viewBox="0 0 100 100"
  //   fill="none"
  //   xmlns="http://www.w3.org/2000/svg"
  //   color={fill}
  //   {...props}
  // >
  // </chakra.svg>
});

export const CreditIcon = createIcon({
  displayName: "CreditIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M1.406 17.023a2.461 2.461 0 002.461 2.46h14.766a2.461 2.461 0 002.46-2.46v-6.768H1.407v6.768zm2.9-3.34a1.318 1.318 0 011.319-1.318h2.11a1.318 1.318 0 011.318 1.318v.879a1.318 1.318 0 01-1.319 1.318H5.625a1.318 1.318 0 01-1.318-1.318v-.879zM18.633 4.014H3.867a2.46 2.46 0 00-2.46 2.461v1.143h19.687V6.475a2.46 2.46 0 00-2.461-2.46z"
    />
  ),
});

export const DashboardLogo = createIcon({
  displayName: "DashboardLogo",
  viewBox: "0 0 1000 257",
  path: (
    <g width="998" height="257" viewBox="0 0 998 257" fill="none">
      <g clipPath="url(#clip0)">
        <path
          d="M388.5 115.302C406.112 115.302 413.966 126.726 416.584 136.96L441.336 127.916C436.576 109.352 419.44 89.836 388.262 89.836C354.942 89.836 329 115.54 329 151.24C329 186.464 354.942 212.882 388.976 212.882C419.44 212.882 436.814 193.128 442.288 175.04L418.012 166.234C415.394 175.04 407.064 187.654 388.976 187.654C371.602 187.654 356.608 174.564 356.608 151.24C356.608 127.916 371.602 115.302 388.5 115.302Z"
          fill="currentColor"
        />
        <path
          d="M484.894 141.244C485.37 126.488 493.7 115.064 508.932 115.064C526.306 115.064 532.732 126.488 532.732 140.768V209.312H560.34V136.008C560.34 110.542 546.536 90.074 517.976 90.074C505.838 90.074 492.748 94.358 484.894 104.592V37H457.286V209.312H484.894V141.244Z"
          fill="currentColor"
        />
        <path
          d="M577.29 177.896C577.29 196.222 592.284 212.882 616.56 212.882C635.362 212.882 646.786 203.362 652.26 194.556C652.26 203.838 653.212 208.598 653.45 209.312H679.154C678.916 208.122 677.726 201.22 677.726 190.748V133.152C677.726 110.066 664.16 89.836 628.46 89.836C599.9 89.836 581.812 107.686 579.67 127.678L604.898 133.39C606.088 121.728 614.18 112.446 628.698 112.446C643.93 112.446 650.594 120.3 650.594 130.058C650.594 134.104 648.69 137.436 642.026 138.388L612.276 142.91C592.522 145.766 577.29 157.19 577.29 177.896ZM621.796 191.224C610.848 191.224 604.898 184.084 604.898 176.23C604.898 166.71 611.8 161.95 620.368 160.522L650.594 156V161.236C650.594 183.846 637.266 191.224 621.796 191.224Z"
          fill="currentColor"
        />
        <path
          d="M810.108 93.406H773.456L728.95 140.292V37H701.58V209.312H728.95V176.944L743.23 161.95L777.264 209.312H811.06L762.508 142.434L810.108 93.406Z"
          fill="currentColor"
        />
        <path
          d="M889.349 92.692C888.159 92.454 885.303 91.978 881.971 91.978C866.739 91.978 853.887 99.356 848.413 111.97V93.406H821.519V209.312H849.127V154.096C849.127 132.438 858.885 120.062 880.305 120.062C883.161 120.062 886.255 120.3 889.349 120.776V92.692Z"
          fill="currentColor"
        />
        <path
          d="M895.968 177.896C895.968 196.222 910.962 212.882 935.238 212.882C954.04 212.882 965.464 203.362 970.938 194.556C970.938 203.838 971.89 208.598 972.128 209.312H997.832C997.594 208.122 996.404 201.22 996.404 190.748V133.152C996.404 110.066 982.838 89.836 947.138 89.836C918.578 89.836 900.49 107.686 898.348 127.678L923.576 133.39C924.766 121.728 932.858 112.446 947.376 112.446C962.608 112.446 969.272 120.3 969.272 130.058C969.272 134.104 967.368 137.436 960.704 138.388L930.954 142.91C911.2 145.766 895.968 157.19 895.968 177.896ZM940.474 191.224C929.526 191.224 923.576 184.084 923.576 176.23C923.576 166.71 930.478 161.95 939.046 160.522L969.272 156V161.236C969.272 183.846 955.944 191.224 940.474 191.224Z"
          fill="currentColor"
        />
        <rect width="257" height="257" rx="128.5" fill="#4FD1C5" />
        <path
          d="M69.5584 133.985L157.15 46.9959C158.787 45.3708 161.42 47.3484 160.315 49.3729L127.714 109.125C126.987 110.457 127.951 112.083 129.47 112.083H185.809C187.624 112.083 188.501 114.306 187.174 115.545L88.4456 207.687C86.6753 209.339 84.0405 207.011 85.4617 205.051L132.197 140.578C133.156 139.256 132.211 137.404 130.578 137.404H70.9677C69.1826 137.404 68.2917 135.243 69.5584 133.985Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="128.5"
          y1="0"
          x2="128.5"
          y2="257"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7BCBD4" />
          <stop offset="1" stopColor="#29C6B7" />
        </linearGradient>
        <clipPath id="clip0">
          <rect width="997.832" height="257" fill="white" />
        </clipPath>
      </defs>
    </g>
  ),
});

export const DashboardLogoWhite = createIcon({
  displayName: "DashboardLogo",
  viewBox: "0 0 163.5 42",
  path: (
    <g fill="none">
      <path
        d="M63.452 19.292c2.877 0 4.16 1.911 4.587 3.623l4.043-1.513c-.777-3.106-3.576-6.371-8.668-6.371-5.443 0-9.68 4.3-9.68 10.274 0 5.893 4.237 10.313 9.796 10.313 4.976 0 7.813-3.305 8.707-6.331l-3.965-1.473c-.427 1.473-1.788 3.583-4.742 3.583-2.837 0-5.286-2.19-5.286-6.092 0-3.903 2.449-6.013 5.208-6.013zM79.196 23.632c.078-2.469 1.438-4.38 3.926-4.38 2.838 0 3.887 1.911 3.887 4.3v11.47h4.51V22.755c0-4.26-2.255-7.685-6.92-7.685-1.982 0-4.12.716-5.403 2.429V6.19h-4.509v28.831h4.51V23.632zM94.287 29.765c0 3.066 2.449 5.853 6.414 5.853 3.071 0 4.936-1.592 5.83-3.066 0 1.553.156 2.35.195 2.47h4.198c-.039-.2-.233-1.355-.233-3.107v-9.637c0-3.862-2.216-7.247-8.047-7.247-4.664 0-7.619 2.986-7.968 6.332l4.12.955c.194-1.951 1.516-3.504 3.887-3.504 2.488 0 3.576 1.314 3.576 2.947 0 .677-.311 1.234-1.399 1.393l-4.859.757c-3.226.478-5.714 2.39-5.714 5.854zm7.269 2.23c-1.788 0-2.76-1.195-2.76-2.509 0-1.593 1.127-2.39 2.527-2.628l4.936-.757v.876c0 3.783-2.176 5.018-4.703 5.018zM132.312 15.628h-5.986l-7.269 7.845V6.191h-4.47v28.83h4.47v-5.416l2.332-2.508 5.559 7.924h5.52l-7.93-11.19 7.774-8.203zM145.254 15.509a6.3 6.3 0 00-1.205-.12c-2.487 0-4.587 1.235-5.481 3.345v-3.106h-4.392v19.393h4.509v-9.238c0-3.624 1.594-5.695 5.092-5.695.467 0 .972.04 1.477.12v-4.7zM146.335 29.765c0 3.066 2.449 5.853 6.414 5.853 3.071 0 4.937-1.592 5.831-3.066 0 1.553.156 2.35.194 2.47h4.199c-.039-.2-.234-1.355-.234-3.107v-9.637c0-3.862-2.215-7.247-8.046-7.247-4.665 0-7.619 2.986-7.969 6.332l4.121.955c.194-1.951 1.516-3.504 3.887-3.504 2.488 0 3.576 1.314 3.576 2.947 0 .677-.311 1.234-1.399 1.393l-4.859.757c-3.227.478-5.715 2.39-5.715 5.854zm7.269 2.23c-1.788 0-2.759-1.195-2.759-2.509 0-1.593 1.127-2.39 2.526-2.628l4.937-.757v.876c0 3.783-2.177 5.018-4.704 5.018zM41.975 21.5C41.975 9.626 32.578 0 20.987 0 9.398 0 0 9.626 0 21.5S9.396 43 20.988 43c11.59 0 20.987-9.626 20.987-21.5z"
        fill="#fff"
      />
      <path
        d="M11.36 22.418L25.668 7.863c.267-.272.697.06.517.398l-5.325 9.997c-.119.223.039.495.287.495h9.202c.296 0 .44.372.223.58L14.446 34.748c-.29.277-.72-.113-.488-.44l7.633-10.788c.157-.221.003-.531-.264-.531H11.59c-.292 0-.437-.362-.23-.572z"
        fill="#3BCBBE"
      />
    </g>
  ),
});

export const DocumentIcon = createIcon({
  displayName: "DocumentIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        fill="currentColor"
        d="M18.809 10.344h-6.153a2.11 2.11 0 01-2.11-2.11V2.083a.176.176 0 00-.175-.176H6.328A2.812 2.812 0 003.516 4.72v14.063a2.812 2.812 0 002.812 2.812h9.844a2.812 2.812 0 002.812-2.813V10.52a.176.176 0 00-.175-.176z"
      />
      <path
        fill="currentColor"
        d="M18.423 8.789l-6.32-6.32a.088.088 0 00-.15.062v5.705a.703.703 0 00.703.703h5.705a.088.088 0 00.062-.15z"
      />
    </g>
  ),
});

export const GlobeIcon = createIcon({
  displayName: "GlobeIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        stroke="currentColor"
        fill="transparent"
        d="M11.25 2.109a9.14 9.14 0 100 18.281 9.14 9.14 0 000-18.281z"
        strokeWidth=".75"
        strokeMiterlimit="10"
      />
      <path
        stroke="currentColor"
        fill="transparent"
        d="M11.25 2.109C8.698 2.109 6.3 6.2 6.3 11.249c0 5.048 2.4 9.14 4.951 9.14 2.552 0 4.951-4.092 4.951-9.14 0-5.048-2.399-9.14-4.95-9.14z"
        strokeWidth=".75"
        strokeMiterlimit="10"
      />
      <path
        stroke="currentColor"
        fill="transparent"
        d="M5.156 5.156C6.836 6.349 8.952 7.06 11.25 7.06c2.298 0 4.414-.711 6.094-1.904"
      />
      <path
        stroke="currentColor"
        fill="transparent"
        d="M5.156 5.156C6.836 6.349 8.952 7.06 11.25 7.06c2.298 0 4.414-.711 6.094-1.904M17.344 17.344c-1.68-1.193-3.796-1.904-6.094-1.904-2.298 0-4.413.711-6.094 1.904"
        strokeWidth=".75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        stroke="currentColor"
        fill="transparent"
        d="M11.25 2.109v18.28M20.39 11.249H2.11"
        strokeWidth=".75"
        strokeMiterlimit="10"
      />
    </g>
  ),
});

export const HelpIcon = createIcon({
  displayName: "HelpIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M11.25 0C5.04 0 0 5.04 0 11.25S5.04 22.5 11.25 22.5 22.5 17.46 22.5 11.25 17.46 0 11.25 0zm-.352 17.813a1.172 1.172 0 110-2.344 1.172 1.172 0 010 2.344zm1.96-5.977c-.95.637-1.08 1.222-1.08 1.758a.82.82 0 11-1.641 0c0-1.284.59-2.305 1.806-3.121 1.13-.758 1.768-1.239 1.768-2.295 0-.718-.41-1.264-1.26-1.668-.199-.095-.644-.187-1.191-.18-.687.008-1.22.172-1.63.503-.775.623-.84 1.302-.84 1.312a.821.821 0 11-1.642-.08c.007-.142.106-1.425 1.452-2.507.698-.562 1.585-.854 2.636-.866.745-.01 1.444.117 1.918.34 1.418.672 2.198 1.79 2.198 3.146 0 1.982-1.325 2.872-2.494 3.658z"
    />
  ),
});

export const HomeIcon = createIcon({
  displayName: "HomeIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        fill="currentColor"
        d="M11.494 4.951a.351.351 0 00-.486 0l-8.09 7.729a.352.352 0 00-.109.254v7.254a1.406 1.406 0 001.405 1.406h4.223a.703.703 0 00.704-.703v-5.976a.351.351 0 01.351-.352h3.516a.351.351 0 01.351.352v5.976a.703.703 0 00.704.703h4.22a1.407 1.407 0 001.407-1.406v-7.254a.35.35 0 00-.108-.254L11.494 4.95z"
      />
      <path
        fill="currentColor"
        d="M21.574 11.23l-3.287-3.144V3.314a.703.703 0 00-.703-.703h-2.11a.703.703 0 00-.703.703V4.72l-2.545-2.434c-.239-.24-.593-.378-.976-.378-.38 0-.734.138-.972.379L.93 11.23a.717.717 0 00-.058.983.703.703 0 001.018.046l9.119-8.713a.352.352 0 01.486 0l9.12 8.713a.703.703 0 00.992-.019c.27-.28.248-.74-.033-1.01z"
      />
    </g>
  ),
});

export const InvisionLogo = createIcon({
  displayName: "InvisionLogo",
  viewBox: "0 0 24 24",
  path: (
    <g clipPath="url(#clip0)">
      <path
        d="M18.687 0H2.313A1.813 1.813 0 00.5 1.811v16.374C.5 19.188 1.312 20 2.313 20h16.374a1.813 1.813 0 001.813-1.813V1.812A1.813 1.813 0 0018.687 0z"
        fill="#DC395F"
      />
      <path
        d="M7.184 6.293c.665 0 1.222-.522 1.222-1.204 0-.683-.557-1.204-1.222-1.204-.665 0-1.222.521-1.222 1.204 0 .682.557 1.204 1.222 1.204zM4.65 12.739a4.134 4.134 0 00-.108.905c0 1.06.575 1.764 1.797 1.764 1.013 0 1.834-.602 2.426-1.573l-.361 1.449h2.012l1.15-4.612c.287-1.168.844-1.774 1.689-1.774.665 0 1.078.413 1.078 1.096 0 .197-.018.413-.09.646l-.593 2.12c-.09.306-.126.611-.126.899 0 1.006.593 1.742 1.833 1.742 1.06 0 1.904-.682 2.371-2.317l-.79-.305c-.395 1.095-.737 1.293-1.006 1.293-.27 0-.414-.18-.414-.538 0-.162.037-.342.09-.558l.575-2.065c.144-.485.198-.915.198-1.31 0-1.546-.934-2.352-2.066-2.352-1.06 0-2.138.956-2.677 1.962l.395-1.806H8.962L8.53 8.996h1.438l-.885 3.544c-.695 1.545-1.972 1.57-2.132 1.534-.264-.06-.432-.159-.432-.5 0-.198.036-.482.126-.823l1.348-5.346H4.579l-.431 1.591h1.419L4.65 12.74"
        fill="#fff"
      />
    </g>
  ),
});

export const JiraLogo = createIcon({
  displayName: "JiraLogo",
  viewBox: "0 0 24 24",
  path: (
    <g clipPath="url(#clip0)">
      <path
        d="M20.26 10.42l-8.863-8.93-.86-.865-6.67 6.722L.814 10.42a.827.827 0 000 1.162l6.096 6.14 3.627 3.654 6.67-6.722.105-.104 2.947-2.964a.824.824 0 000-1.166zm-9.722 3.649L7.493 11l3.045-3.068L13.582 11l-3.044 3.068z"
        fill="#2684FF"
      />
      <path
        d="M10.537 7.932a5.184 5.184 0 01-1.502-3.637A5.185 5.185 0 0110.515.65L3.852 7.36l3.626 3.654 3.06-3.082z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M13.59 10.992l-3.053 3.076a5.186 5.186 0 011.502 3.653c0 1.37-.54 2.683-1.502 3.652l6.682-6.728-3.63-3.653z"
        fill="url(#paint1_linear)"
      />
    </g>
  ),
});

export const MastercardIcon = createIcon({
  displayName: "MastercardIcon",
  viewBox: "0 0 24 24",
  path: (
    <svg
      width="24"
      height="20"
      viewBox="0 0 21 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6.63158" cy="7.49999" r="6.63158" fill="#EB001B" />
      <circle cx="14.3686" cy="7.49999" r="6.63158" fill="#F79E1B" />
    </svg>
  ),
});

export const PayPalIcon = createIcon({
  displayName: "PayPalIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        fill="currentColor"
        d="M16.179 2.532C15.142 1.357 13.265.854 10.863.854H3.895a.997.997 0 00-.986.834L.007 19.945a.595.595 0 00.591.686H4.9l1.08-6.8-.033.215a.993.993 0 01.983-.834h2.044c4.017 0 7.16-1.619 8.08-6.3.027-.14.07-.406.07-.406.262-1.732-.001-2.907-.945-3.974z"
      />
      <path
        fill="currentColor"
        d="M18.213 7.393c-.998 4.61-4.184 7.048-9.24 7.048H7.142L5.773 23.1h2.973a.87.87 0 00.862-.731l.035-.184.684-4.297.044-.237a.87.87 0 01.86-.731h.544c3.514 0 6.264-1.416 7.068-5.51.322-1.644.166-3.021-.63-4.017z"
      />
    </g>
  ),
});

export const PersonIcon = createIcon({
  displayName: "PersonIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M14.618 3.338c-.855-.924-2.05-1.432-3.368-1.432-1.325 0-2.524.505-3.375 1.423-.86.928-1.28 2.188-1.181 3.55.195 2.686 2.239 4.87 4.556 4.87s4.358-2.184 4.556-4.87c.1-1.349-.322-2.607-1.188-3.541zM18.984 21.592H3.515a1.363 1.363 0 01-1.063-.489 1.552 1.552 0 01-.316-1.279c.371-2.058 1.529-3.786 3.348-5 1.616-1.076 3.664-1.67 5.766-1.67s4.15.594 5.765 1.67c1.82 1.214 2.977 2.942 3.348 5 .085.471-.03.937-.315 1.279a1.362 1.362 0 01-1.064.49z"
    />
  ),
});

export const ProfileIcon = createIcon({
  displayName: "ProfileIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path d="M0 0h24v24H0V0z" fill="transparent" />
      <path
        fill="currentColor"
        d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4z"
      />
    </g>
  ),
});

export const RocketIcon = createIcon({
  displayName: "RocketIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        fill="currentColor"
        d="M20.99 2.182a.209.209 0 00-.156-.16c-2.574-.63-8.521 1.613-11.743 4.833a13.93 13.93 0 00-1.566 1.85c-.994-.087-1.987-.014-2.834.355-2.39 1.052-3.085 3.796-3.279 4.976a.424.424 0 00.464.492l3.837-.423c.002.29.02.578.052.866.02.2.108.386.25.527l1.486 1.482a.86.86 0 00.528.25c.286.033.573.05.86.053l-.42 3.832a.424.424 0 00.492.464c1.178-.19 3.927-.885 4.972-3.274.37-.847.445-1.836.36-2.824a13.96 13.96 0 001.855-1.567c3.232-3.216 5.462-9.03 4.842-11.732zm-8.067 7.896a2.11 2.11 0 112.983-2.984 2.11 2.11 0 01-2.983 2.984z"
      />
      <path
        fill="currentColor"
        d="M7.4 18.054c-.24.241-.627.335-1.092.416-1.044.178-1.967-.725-1.779-1.78.072-.401.283-.962.415-1.094a.192.192 0 00-.16-.328 2.636 2.636 0 00-1.544.753c-1.033 1.034-1.13 4.87-1.13 4.87s3.838-.097 4.872-1.13c.417-.417.682-.961.752-1.546.017-.184-.207-.293-.334-.16z"
      />
    </g>
  ),
});

export const SettingsIcon = createIcon({
  displayName: "SettingsIcon",
  viewBox: "0 0 24 24",
  // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
  path: (
    <g>
      <path d="M0,0h24v24H0V0z" fill="none" />
      <path
        fill="currentColor"
        d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"
      />
    </g>
  ),
});

export const SlackLogo = createIcon({
  displayName: "SlackLogo",
  viewBox: "0 0 24 24",
  path: (
    <g clipPath="url(#clip0)" fillRule="evenodd" clipRule="evenodd">
      <path
        d="M7.832.5c-1.105 0-2 .919-1.999 2.05 0 1.13.895 2.048 2 2.05h2V2.55c.001-1.13-.894-2.048-2-2.05zm0 5.467H2.5c-1.106 0-2.001.918-2 2.05-.002 1.13.894 2.048 2 2.05h5.332c1.106-.001 2.002-.919 2-2.05.002-1.132-.894-2.05-2-2.05z"
        fill="#36C5F0"
      />
      <path
        d="M20.5 8.016c0-1.13-.895-2.048-2-2.05-1.106.002-2.002.92-2 2.05v2.05h2c1.105 0 2-.918 2-2.05zm-5.334 0V2.55c.001-1.13-.893-2.048-2-2.05-1.105 0-2 .919-2 2.05v5.466c-.001 1.131.894 2.049 2 2.05 1.106 0 2.001-.918 2-2.05z"
        fill="#2EB67D"
      />
      <path
        d="M13.166 21c1.106 0 2.001-.919 2-2.05.001-1.13-.894-2.048-2-2.05h-2v2.05c-.001 1.13.894 2.048 2 2.05zm0-5.467h5.333c1.106-.001 2.002-.92 2-2.05.002-1.131-.893-2.049-1.999-2.05h-5.333c-1.106 0-2.001.918-2 2.05-.001 1.13.893 2.049 1.999 2.05z"
        fill="#ECB22E"
      />
      <path
        d="M.5 13.483c-.001 1.13.895 2.049 2 2.05 1.106-.001 2.001-.92 2-2.05v-2.05h-2c-1.105.001-2.001.919-2 2.05zm5.333 0v5.467c-.001 1.13.894 2.048 2 2.05 1.105 0 2-.919 2-2.05v-5.465c.002-1.131-.894-2.05-2-2.05-1.106 0-2 .917-2 2.048z"
        fill="#E01E5A"
      />
    </g>
  ),
});

export const SpotifyLogo = createIcon({
  displayName: "SpotifyLogo",
  viewBox: "0 0 24 24",
  path: (
    <g clipPath="url(#clip0)">
      <path
        d="M10.5 0C4.977 0 .5 4.477.5 10s4.477 10 10 10 10-4.477 10-10c0-5.522-4.477-10-10-10zm4.586 14.422a.623.623 0 01-.857.208c-2.348-1.435-5.304-1.76-8.785-.964a.623.623 0 11-.277-1.216c3.808-.87 7.076-.495 9.712 1.115.294.181.387.564.207.857zm1.223-2.722a.78.78 0 01-1.072.257c-2.687-1.652-6.786-2.13-9.965-1.166a.78.78 0 01-.973-.519.781.781 0 01.52-.972c3.632-1.102 8.147-.569 11.233 1.329a.78.78 0 01.258 1.072zm.106-2.835C13.19 6.95 7.875 6.775 4.797 7.708a.935.935 0 11-.543-1.79c3.533-1.072 9.404-.865 13.115 1.338a.935.935 0 01-.954 1.609z"
        fill="#2EBD59"
      />
    </g>
  ),
});

export const SupportIcon = createIcon({
  // Doesn't display the full icon without w and h being specified
  displayName: "BuildIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M20.885 5.547a.703.703 0 00-1.122-.176l-2.7 2.702a.708.708 0 01-.995 0l-1.167-1.169a.702.702 0 010-.994l2.689-2.69a.704.704 0 00-.21-1.138c-2.031-.908-4.566-.435-6.164 1.152-1.358 1.348-1.763 3.455-1.11 5.78a.698.698 0 01-.197.703L2.593 16.4a2.82 2.82 0 103.981 3.983l6.754-7.332a.699.699 0 01.693-.2 7.885 7.885 0 002.03.279c1.469 0 2.757-.475 3.686-1.39 1.72-1.695 1.983-4.57 1.148-6.192zM4.623 19.901a1.407 1.407 0 11-.305-2.797 1.407 1.407 0 01.305 2.797z"
    />
  ),
});

export const StatsIcon = createIcon({
  displayName: "StatsIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M4.57 22.297H3.164a1.055 1.055 0 01-1.055-1.054v-6.328a1.055 1.055 0 011.055-1.055H4.57a1.055 1.055 0 011.055 1.055v6.328a1.055 1.055 0 01-1.055 1.054zM14.414 22.296h-1.406a1.055 1.055 0 01-1.055-1.055V10.695a1.055 1.055 0 011.055-1.055h1.406a1.055 1.055 0 011.055 1.055V21.24a1.055 1.055 0 01-1.055 1.055zM19.336 22.297H17.93a1.055 1.055 0 01-1.055-1.055V5.773A1.055 1.055 0 0117.93 4.72h1.406a1.055 1.055 0 011.055 1.054v15.47a1.055 1.055 0 01-1.055 1.054zM9.492 22.297H8.086a1.055 1.055 0 01-1.055-1.055V2.257a1.055 1.055 0 011.055-1.054h1.406a1.055 1.055 0 011.055 1.054v18.985a1.055 1.055 0 01-1.055 1.055z"
    />
  ),
});

export const WalletIcon = createIcon({
  displayName: "WalletIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        fill="currentColor"
        d="M4.447 4.818h14.062c.164 0 .328.01.491.031a2.9 2.9 0 00-3.406-2.441L4.03 4.382h-.013a2.9 2.9 0 00-1.805 1.149 3.848 3.848 0 012.236-.713zM18.51 5.875H4.446a2.816 2.816 0 00-2.813 2.812v8.438a2.816 2.816 0 002.813 2.812h14.062a2.815 2.815 0 002.813-2.812V8.687a2.815 2.815 0 00-2.813-2.812zm-2.088 8.437a1.406 1.406 0 110-2.811 1.406 1.406 0 010 2.811z"
      />
      <path
        fill="currentColor"
        d="M1.656 11.651V7.28c0-.952.528-2.549 2.358-2.895 1.553-.291 3.091-.291 3.091-.291s1.011.703.176.703-.813 1.077 0 1.077 0 1.032 0 1.032L4.007 10.62l-2.35 1.032z"
      />
    </g>
  ),
});

export const VisaIcon = createIcon({
  displayName: "VisaIcon",
  viewBox: "0 0 24 24",
  path: (
    <svg
      width="26"
      height="20"
      viewBox="0 0 30 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6708 2.96349C12.6568 4.15055 13.653 4.81298 14.4034 5.20684C15.1744 5.61099 15.4333 5.87013 15.4304 6.23147C15.4245 6.78459 14.8153 7.02862 14.2452 7.03812C13.2505 7.05475 12.6723 6.74889 12.2125 6.51753L11.8542 8.32341C12.3155 8.55247 13.1696 8.75217 14.0554 8.76087C16.1345 8.76087 17.4947 7.65543 17.5021 5.94145C17.5102 3.76625 14.7087 3.64579 14.7278 2.67348C14.7344 2.37871 14.9956 2.06408 15.568 1.98406C15.8512 1.94368 16.6332 1.91274 17.5198 2.35252L17.8677 0.605286C17.391 0.418253 16.7782 0.239136 16.0153 0.239136C14.0583 0.239136 12.6819 1.35962 12.6708 2.96349ZM21.2115 0.389687C20.8319 0.389687 20.5118 0.628245 20.3691 0.99433L17.3991 8.63249H19.4767L19.8901 7.40183H22.429L22.6689 8.63249H24.5L22.9021 0.389687H21.2115ZM21.5021 2.61641L22.1016 5.7116H20.4596L21.5021 2.61641ZM10.1518 0.389687L8.51418 8.63249H10.4939L12.1308 0.389687H10.1518ZM7.22303 0.389687L5.16233 6.00003L4.32878 1.22966C4.23097 0.697187 3.84472 0.389687 3.41579 0.389687H0.0471011L0 0.629037C0.691574 0.790671 1.47729 1.0514 1.95326 1.33033C2.24457 1.50067 2.32775 1.64964 2.42336 2.05458L4.00214 8.63249H6.0945L9.3021 0.389687H7.22303Z"
        fill="#4318FF"
      />
    </svg>
  ),
});
